import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Icon as SDSIcon, Typography } from "@bookips/sds";
import * as Select from "@radix-ui/react-select";
/**
 * 1depth 카테고리 선택을 위한 드롭다운 컴포넌트
 */ export const DepthCategorySelector = (param)=>{
    let { categories , currentCategoryId , onCategoryChange  } = param;
    if (!categories.length) return null;
    // MX-364: 카테고리 핸들러 클릭 이벤트
    const handleCategoryChange = (categoryId)=>{
        const selectedCategory = categories.find((c)=>c.categoryId === categoryId);
        mixpanelEvent("Category Handler Clicked", {
            "Category Type": (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.title) || ""
        });
        onCategoryChange(categoryId);
    };
    return /*#__PURE__*/ _jsxs(Select.Root, {
        value: currentCategoryId,
        onValueChange: handleCategoryChange,
        children: [
            /*#__PURE__*/ _jsx(Select.Trigger, {
                className: cn("group flex items-center justify-center size-6 shrink-0 outline-none", "border border-gray-200 rounded-sm", "hover:bg-gray-900/[0.06] active:bg-gray-900/12", "transition-colors duration-150"),
                "aria-label": "1depth 카테고리 선택",
                children: /*#__PURE__*/ _jsx(Select.Icon, {
                    children: /*#__PURE__*/ _jsx(SDSIcon.Triangle, {
                        className: "text-primary size-4.5 transition-transform duration-200 group-data-[state=open]:rotate-180"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Select.Portal, {
                children: /*#__PURE__*/ _jsx(Select.Content, {
                    className: cn("z-[100] min-w-[120px] overflow-hidden", "bg-white rounded-md py-2", "shadow-[0px_1px_4px_0px_rgba(0,0,0,0.04),0px_2px_8px_0px_rgba(0,0,0,0.08)]"),
                    position: "popper",
                    sideOffset: 4,
                    align: "start",
                    children: /*#__PURE__*/ _jsx(Select.Viewport, {
                        children: categories.map((category)=>/*#__PURE__*/ _jsx(Select.Item, {
                                value: category.categoryId,
                                className: cn("flex items-center px-3 py-2 cursor-pointer outline-none", "data-[state=checked]:bg-indigo-0 data-[state=checked]:text-primary-main", "data-[highlighted]:bg-gray-300/20"),
                                children: /*#__PURE__*/ _jsx(Select.ItemText, {
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body2",
                                        children: category.title
                                    })
                                })
                            }, category.categoryId))
                    })
                })
            })
        ]
    });
};
